import { type Routes } from '@angular/router';

import { authGuard } from '@core/auth/auth.guard';
import { dashboardAccessGuard } from '@shared/dashboards/dashboard-access.guard';
import { prefetchAquaparkFilters } from './features/dashboards/aquapark-flash/aquapark-prefetch';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [dashboardAccessGuard],
    loadComponent: () =>
      import('./layout/app-shell/app-shell.component').then((module) => module.AppShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Дашборды — Васта: Аналитика',
        loadComponent: () =>
          import('./features/home/home.component').then((module) => module.HomeComponent),
      },
      {
        path: 'dashboards/restaurant-flash',
        title: 'Restaurant Flash — Васта: Аналитика',
        loadComponent: () =>
          import('./features/dashboards/restaurant-flash/restaurant-flash-dashboard.component').then(
            (module) => module.RestaurantFlashDashboardComponent,
          ),
      },
      {
        path: 'dashboards/aquapark-flash',
        title: 'Aquapark Flash — Васта: Аналитика',
        canMatch: [prefetchAquaparkFilters],
        loadComponent: () =>
          import('./features/dashboards/aquapark-flash/aquapark-flash-dashboard.component').then(
            (module) => module.AquaparkFlashDashboardComponent,
          ),
      },
      {
        path: 'dashboards/quality',
        title: 'Дашборд качества — РУСЛЕТ',
        loadComponent: () =>
          import('./features/dashboards/quality/quality-dashboard.component').then(
            (module) => module.QualityDashboardComponent,
          ),
      },
      {
        path: 'dashboards/payments',
        title: 'Расходование ДС — РУСЛЕТ',
        loadComponent: () =>
          import('./features/dashboards/payments/payments-dashboard.component').then(
            (module) => module.PaymentsDashboardComponent,
          ),
      },
      {
        path: 'dashboards/production',
        title: 'План и производство — РУСЛЕТ',
        loadComponent: () =>
          import('./features/dashboards/production/production-dashboard.component').then(
            (module) => module.ProductionDashboardComponent,
          ),
      },
      {
        path: 'dashboards/finance',
        title: 'Финансовая сводка — РУСЛЕТ',
        loadComponent: () =>
          import('./features/dashboards/finance/finance-dashboard.component').then(
            (module) => module.FinanceDashboardComponent,
          ),
      },
      {
        path: 'dashboards/manager-flash',
        title: 'Manager Flash — Васта: Аналитика',
        loadComponent: () =>
          import('./features/dashboards/manager-flash/manager-flash-dashboard.component').then(
            (module) => module.ManagerFlashDashboardComponent,
          ),
      },
    ],
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    title: 'Личный кабинет — Васта: Аналитика',
    loadComponent: () =>
      import('./features/profile/profile.component').then((module) => module.ProfileComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
